import { Input } from "@clipboard-health/ui-components";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import { IconButton } from "@src/appV2/redesign/components/IconButton";

import { usePostReplyWithCacheUpdate } from "./usePostReplyWithCacheUpdate";

interface WorkplaceCommentPostReplyFooterProps {
  workplaceId: string;
  parentId: string;
}

export function WorkplaceCommentPostReplyFooter(props: WorkplaceCommentPostReplyFooterProps) {
  const { workplaceId, parentId } = props;

  const { postReply, isPostingReply, text, setText } = usePostReplyWithCacheUpdate({
    workplaceId,
    parentId,
    source: "detail_page",
  });

  return (
    <DialogFooter withShadow orientation="horizontal">
      <Input
        placeholder="Post a comment..."
        value={text}
        onChange={(event) => {
          setText(event.target.value);
        }}
      />
      <IconButton
        iconType="arrow-up"
        variant="contained"
        disabled={!text || isPostingReply}
        onClick={() => {
          postReply({ text, parentId });
        }}
      />
    </DialogFooter>
  );
}
